
        var result = require("!!../../../../node_modules/css-loader/index.js!./used-giftcertificates.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/administration/used-giftcertificates/used-giftcertificates.component.css
// module id = 2528
// module chunks = 1